import React                from "react";
import Action               from "Dashboard/Core/Action";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import StateEdit            from "./StateEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The State List
 * @returns {React.ReactElement}
 */
function StateList() {
    const { fetch, load } = useList("memberState");

    const data = Store.useState("memberState");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("memberState");

    // The Current State
    const [ action, elemCode, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemCode);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "stateCode", elemCode, "name");

    return <Main>
        <Header message="MEMBERS_STATES_NAME" icon="state">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="MEMBERS_STATES_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="stateCode"    message="GENERAL_CODE"                 maxWidth="100" />
                    <TableHeader field="name"         message="GENERAL_NAME"                 isTitle />
                    <TableHeader field="allowsAccess" message="MEMBERS_STATES_ALLOWS_ACCESS" align="center" maxWidth="120" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.stateCode} elemID={elem.stateCode}>
                        <TableCell message={elem.stateCode}        />
                        <TableCell message={elem.name}             />
                        <TableCell message={elem.allowsAccessText} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="MEMBERS_STATES_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="MEMBERS_STATES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <StateEdit
            open={action.isVCE}
            elemCode={elemCode}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="MEMBERS_STATES_DELETE_TITLE"
            message="MEMBERS_STATES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default StateList;
